<template>
  <PulsBackground background-variant="3">
    <ThemeSelector />
    <PulsNavigationMenu
      v-if="isLoggedIn && idToken"
      current-item="help"
      :router="$router"
      :custom-menu="customMenu"
      :id-token="idToken"
      :available-locales="availableLocales"
      :current-locale="$i18n.locale"
      :translate="$t"
      :on-locale-change="changeLanguage"
      :on-logout="logout"
      :show-logo="true"
    />
    <div class="mt-20 mb-20">
      <router-view />
    </div>
  </PulsBackground>
</template>

<script>
import Amplify from 'aws-amplify'
import { PulsNavigationMenu } from '@puls-solutions/pulsmeter-menu'
import {
  PulsBackground,
  ThemeSelector
} from '@puls-solutions/puls-ui-components'

export default {
  name: 'App',
  components: {
    PulsNavigationMenu,
    PulsBackground,
    ThemeSelector
  },
  data() {
    return {
      customMenu: null
    }
  },
  mounted() {
    this.configureAmplify()
    if (!this.isLoggedIn) {
      this.checkAuth()
    }
    if (
      '-ms-scroll-limit' in document.documentElement.style &&
      '-ms-ime-align' in document.documentElement.style
    ) {
      // detect it's IE11
      const handleIERouting = () => {
        const currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }
      window.removeEventListener('hashchange', handleIERouting)
      window.addEventListener('hashchange', handleIERouting, false)
    }
  },
  computed: {
    isLoggedIn: function () {
      return this.loggedInUser && this.hasToken
    },
    loggedInUser: function () {
      return this.$store.getters.loggedInUser
    },
    hasToken: function () {
      return this.$store.getters.hasToken
    },
    idToken() {
      const user = this.loggedInUser
      return user && user.signInUserSession && user.signInUserSession.idToken
        ? user.signInUserSession.idToken.payload
        : null
    },
    availableLocales() {
      return Object.keys(this.$i18n.messages || {})
    }
  },
  methods: {
    checkAuth: function () {
      this.$store.dispatch('checkAuthentication')
    },
    changeLanguage(locale) {
      this.$i18n.locale = locale
      localStorage.setItem('selectedLocale', locale)
    },
    logout() {
      window.location = '/#/start'
    },
    configureAmplify() {
      if (localStorage.orgData) {
        const orgResult = JSON.parse(localStorage.orgData)
        if (orgResult.orgSettings && orgResult.orgSettings.customMenu) {
          this.customMenu = orgResult.orgSettings.customMenu
        }
        const configObject = {
          Auth: {
            identityPoolId: orgResult.identityPoolId,
            region: 'eu-west-1',
            userPoolId: orgResult.userPoolId,
            userPoolWebClientId: orgResult.userPoolWebClientId,
            mandatorySignIn: true
          }
        }
        Amplify.configure(configObject)
      }
    }
  }
}
</script>

<style>
body {
  height: inherit !important;
  /* background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.1)),
    url('./assets/img/help.jpg');
  background-size: cover;
  background-blend-mode: darken;
  background-repeat: no-repeat;
  background-attachment: fixed; */
}
.puls-background {
  overflow: scroll;
}
</style>
